
export const defaultSelectedWarehouse = () => {
  return {
    id: null,
    city_id: "",
    country_id:1,
    code: "",
    description: "",
    address: "",
    latitude: "",
    length: "",
    telephone: "",
    email: "",
    seller_id: null,
    observation: "",
    state: 1,
    excluded_taxes: 0,
    branchoffice_id: "",
    creation_date: new Date(),
    other_telephones: null,
    payment_type_id: null,
    discount_percentage: null,
    zone_id:null,
    types_negotiation_portfolio: null,
    city:{},
    zone_despatch_id:null,
    ret_ica_provider_account_id:null,
    ret_ica_account_id:null,
    retIcaAccount: {},
    retIcaProvideerAccount: {},
    ret_fue_provider_account_id:null,
    ret_fue_account_id:null,
    retFueAccount: {},
    retFueProviderAccount: {},
    no_base_value:false
  };
};

export default {
  accounts:[],
  departments:[],
  cities: [],
  warehouses: [],
  selectedWarehouse: defaultSelectedWarehouse(),
  error: false,
  errorMessage: "",
  actionWarehouse: "create",
  citiesWarehouses: [],
  sellers: [],
  paymentMethods: [],
  types_negotiation_portfolio: [],
  zones:[],
  zones_despatch:[]
};



// WEBPACK FOOTER //
// ./src/modules/contacts-warehouses/state.js